export default {
  LOGOUT_CURRENT_USER: 'LOGOUT_CURRENT_USER',
  SET_USER: 'SET_USER',
  UPDATE_DEVICE_INNER_WIDTH: 'UPDATE_DEVICE_INNER_WIDTH',
};
